import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const latestArticles = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">持续更新的影史研究内容</p>
          </div>
          <Link
            to="/category/fenji-zhidu"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/fenji-zhidu"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}